import React from 'react';
import styled from 'styled-components';

import EmailFillIcon from '@ad-scripts/presentation/components/common/icons/fill/email-fill';
import StackContainer from '@ad-scripts/presentation/components/common/containers/stack_container';
import { Button } from 'src/presentation/components/agent_desktop_components';
import { H2 } from '@ad-scripts/presentation/components/common/headers';
import { Section } from 'src/presentation/components/forms/Layout';
import { useAddEmailAddress } from './hooks/useAddEmailAddress';

const EmailAddressEmptyPage = ({ errors, onCreate }): JSX.Element => {
  const { onEmailDomainSave, renderEmailDomainForm } = useAddEmailAddress({
    errors,
    onSaveSuccess: onCreate,
  });

  return (
    <EmptyPageLayout data-aid="empty-domain-page">
      <StyledEmailFillIcon />
      <H2 data-aid="header-title">Add email address</H2>
      <EmptyPageDescription data-aid="header-description">
        Enter an email address associated with a sending domain you want to send emails from in Gladly.
      </EmptyPageDescription>

      <StyledSection>{renderEmailDomainForm()}</StyledSection>

      <Button type={Button.Types.PRIMARY} onClick={onEmailDomainSave} data-aid="save-and-continue-button">
        Next
      </Button>
    </EmptyPageLayout>
  );
};

const StyledSection = styled(Section)`
  margin-bottom: 0;
`;

const EmptyPageLayout = styled(StackContainer).attrs({ stack: 'none', inset: 'none' })`
  align-items: center;
  background-color: ${p => p.theme.colors.white};
  justify-content: center;
  line-height: 162%;
  margin: 24px 8px;
  width: 100%;
`;

const StyledEmailFillIcon = styled(EmailFillIcon)`
  fill: ${({ theme }) => theme.colors.gray600};
  margin-bottom: 20px;
  width: 40px;
`;

const EmptyPageDescription = styled.div`
  margin-bottom: 24px;
  max-width: 460px;
  text-align: center;
`;

export default EmailAddressEmptyPage;
